<script>
  import { format } from 'date-fns';
  import { capfirst, intcomma } from 'journalize';
  import { dateParser } from '../../utils/d3-utils';
  import { getSortByString, getSortByNumber } from '../../utils/sorters';

  // the hook for supplied props
  export let data;
  export let include_percapita;

  const getNewCasesHeader = () => {
    const dt = dateParser(data.max_date);
    const diff = new Date().getDate() - dt.getDate();
    if (diff < 6) {
      return format(dt, 'EEEE');
    } else {
      return format(dt, 'MMM d');
    }
  };

  // Prep the data
  let headers;
  if (include_percapita) {
    headers = [
      { text: 'Area', class: 'text-left sortable', attr: 'name' },
      {
        text: 'Cases',
        class: 'text-right sortable',
        attr: 'confirmed_cases',
      },
      {
        text: 'Per 10k',
        class: 'text-right sortable',
        attr: 'confirmed_cases_per_100k',
      },
      {
        text: getNewCasesHeader(),
        class: 'text-right sortable',
        attr: 'new_confirmed_cases',
      },
    ];
  } else {
    headers = [
      { text: 'Area', class: 'text-left sortable', attr: 'name' },
      {
        text: 'Cases',
        class: 'text-right sortable',
        attr: 'confirmed_cases',
      },
      {
        text: getNewCasesHeader(),
        class: 'text-right sortable',
        attr: 'new_confirmed_cases',
      },
    ];
  }
  let sortAttr = 'confirmed_cases';
  let sortAscending = false;
  let sortFunctions = {
    name: {
      true: getSortByString('sort_text', true),
      false: getSortByString('sort_text', false),
    },
    confirmed_cases: {
      true: getSortByNumber('confirmed_cases', true),
      false: getSortByNumber('confirmed_cases', false),
    },
    confirmed_cases_per_100k: {
      true: getSortByNumber('confirmed_cases_per_100k', true),
      false: getSortByNumber('confirmed_cases_per_100k', false),
    },
    new_confirmed_cases: {
      true: getSortByNumber('new_confirmed_cases', true),
      false: getSortByNumber('new_confirmed_cases', false),
    },
  };

  // Table row limit
  const limit = 10;
  let showAll = false;

  // computed values
  const getSortText = (t) => {
    if (t.includes(':')) {
      return t.split(':')[1].trim();
    } else {
      return t.trim();
    }
  };
  let preppedData = data.places.map((d) => {
    d.search_text = d.name.toUpperCase();
    d.sort_text = getSortText(d.name);
    return d;
  });
  $: filteredData = preppedData;
  $: tableRows = filteredData.sort(sortFunctions[sortAttr][sortAscending]);
  $: enoughRows = tableRows.length > limit;

  // flip the toggle on each click
  function onToggle() {
    showAll = !showAll;
  }

  // Filter table
  function filterRows(e) {
    showAll = false;
    const value = e.target.value.toUpperCase();
    if (value == '') {
      filteredData = preppedData;
    } else {
      filteredData = preppedData.filter(
        (d) => d.search_text.indexOf(value) > -1
      );
    }
  }

  function onSort(e) {
    const thisAttr = e.target.getAttribute('data-attr');
    if (thisAttr === sortAttr) {
      sortAscending = !sortAscending;
    } else {
      sortAttr = thisAttr;
      sortAscending = true;
    }
  }
</script>

<div>
  {#if data.places.length > limit}
    <div class="dg-table--narrow dg-table--inputs">
      <label class="search" for="county-place-table-input">Search by name</label
      >
      <input
        class="search"
        id="county-place-table-input"
        on:keyup={filterRows}
      />
    </div>
  {/if}
  <table class="dg-table dg-table--narrow">
    <thead>
      <tr>
        {#each headers as obj}
          <th
            scope="col"
            data-attr={obj.attr}
            class={obj.class}
            class:sort-asc={sortAttr === obj.attr && sortAscending}
            class:sort-desc={sortAttr === obj.attr && !sortAscending}
            style={obj.style}
            on:click={onSort}
          >
            {obj.text}
          </th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each tableRows as obj, idx}
        <tr class:display-none={enoughRows && idx + 1 > limit && !showAll}>
          <th scope="row" class="text-left">{capfirst(obj.name)}</th>
          <td class="text-right">
            {obj.confirmed_cases_note || intcomma(obj.confirmed_cases)}
          </td>
          {#if include_percapita}
            <td class="text-right lighter" style="padding-right: 5px;">
              {intcomma((obj.confirmed_cases_per_100k / 10).toFixed(1))}
            </td>
          {/if}
          <td class="text-right" style="padding-right: 5px;">
            +{intcomma(obj.new_confirmed_cases)}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
  <div class="text-center">
    {#if enoughRows}
      <button class="btn" on:click={onToggle}>
        {showAll ? 'Show less' : 'Show all'}
      </button>
    {/if}
  </div>
</div>
